const SELECTORS = {
  container: '[data-first-content]',
  comments: '[data-match-comments]',
  infobox: '[data-info-box-error]',
};

/**
 * Vloží informační box o offline stavu do sekce komentářů.
 * Pokud box již existuje, funkce nic nevloží.
 *
 * @param message Text zprávy, která se má zobrazit uživateli
 */
export const showOfflineInfoBox = (
  message: string = 'Jste offline, prosím přenačtěte si stránku.'
): void => {
  // Najde hlavní kontejner
  const container = document.querySelector<HTMLElement>(SELECTORS.container);

  // Najde sekci s komentáři
  const containerComments = container?.querySelector<HTMLElement>(SELECTORS.comments);

  // Pokud sekce s komentáři neexistuje, vypíše varování a ukončí funkci
  if (!containerComments) {
    console.warn('Element [data-match-comments] nebyl nalezen.');
    return;
  }

  // Pokud už offline informační box existuje, funkce jej nevytvoří znovu
  if (containerComments.querySelector(SELECTORS.infobox)) return;

  // HTML kód informačního boxu
  const infoBoxHtml = `
    <div class="info-box info-box--visible info-box--info info-box--transition"
         data-info-box-error>
      <span class="info-box__icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 
                   6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 
                   17.52 22 12C22 6.48 17.52 2 12 2ZM12 
                   20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 
                   12 4C16.41 4 20 7.59 20 12C20 16.41 
                   16.41 20 12 20Z" fill="#191919"></path>
        </svg>
      </span>
      <span class="typography typography--body1-bold info-box__text">
        ${message}
      </span>
    </div>
  `;

  // Vloží informační box na začátek sekce komentářů
  containerComments.insertAdjacentHTML('afterbegin', infoBoxHtml);
};
